import { Card as PrimeCard } from "primereact/card";
import './Layout.css';




export function Card({ children, className, noMargin: removeMargin, disableClick }: { children: React.ReactNode, className?: string, noMargin?: boolean, disableClick?: boolean }) {
    const removeMarginClass = removeMargin === true ? '' : ' gl-with-margin';
    const clickableClass = disableClick ? '' : ' gl-clickable';
    return (
        <PrimeCard className={`gl-content-card ${className}${removeMarginClass}${clickableClass}`}>
            {children}
        </PrimeCard>
    );
}
